import { ConcreteEncodable } from "./ConcreteEncodable";

import { BigDecimalComparitorImplEncoder } from "../../encoder/BigDecimalComparitorImplEncoder";

import * as CubiqTS from "../../index";
import { BigDecimalComparitor } from "../BigDecimalComparitor";

export class BigDecimalComparitorImpl extends ConcreteEncodable implements BigDecimalComparitor {
  public static enType: string = "com.bcdfx.model.BigDecimalComparitorImpl";

  /*FID=1*/
  public comparitor: CubiqTS.OperatorComparison;
  /*FID=2*/
  public lowerBound: CubiqTS.BigNumber | null = null;
  /*FID=3*/
  public upperBound: CubiqTS.BigNumber | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BigDecimalComparitorImplEncoder.Instance;
    this.setEncodableType(BigDecimalComparitorImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BigDecimalComparitorImpl[" +
      "comparitor=" +
      this.comparitor +
      "lowerBound=" +
      this.lowerBound +
      "upperBound=" +
      this.upperBound +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
